var map = {
	"./AmiyaBagchi.jpg": 624,
	"./AmiyaBagchi.png": 625,
	"./ChinmayTumbe.png": 626,
	"./DavidArnold.jpg": 627,
	"./DavidArnold.png": 628,
	"./DouglasHaynes.jpg": 629,
	"./DouglasHaynes.png": 630,
	"./DwijendraTripathi.jpg": 631,
	"./DwijendraTripathi.png": 632,
	"./GeoffreyJones.png": 633,
	"./IndiraChowdhury.jpg": 634,
	"./IndiraChowdhury.png": 635,
	"./JosephSassoon.jpg": 636,
	"./JosephSassoon.png": 637,
	"./MedhaKudaisya.jpg": 638,
	"./MedhaKudaisya.png": 639,
	"./MilanBalaban.png": 640,
	"./PrafullAnubhai.jpg": 641,
	"./PrafullAnubhai.png": 642,
	"./RamachandraGuha.png": 643,
	"./RituBirla.jpg": 644,
	"./RituBirla.png": 645,
	"./RobertPerks.png": 646,
	"./RossBassett.jpg": 647,
	"./RossBassett.png": 648,
	"./SusiePak.png": 649,
	"./SvenBeckert.png": 650,
	"./SvenBeckertOld.png": 651,
	"./TirthankarRoy.jpg": 652,
	"./TirthankarRoy.png": 653
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 623;